/**
 * Tackle.au logo — a stylised fishhook with rod-and-line motion, drawn
 * in SVG so it scales crisply.  Designed to read at 24px favicon size
 * up to a 400px hero treatment.
 */
export default function TackleLogo({ size = 36, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={`tackle-logo ${className}`}
      aria-label="Tackle.au"
      data-testid="tackle-logo"
    >
      <defs>
        <linearGradient id="tackleHookGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#7be3ff" />
          <stop offset="55%" stopColor="#1aa3c7" />
          <stop offset="100%" stopColor="#063d52" />
        </linearGradient>
        <linearGradient id="tackleLineGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#f6fbff" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#7be3ff" stopOpacity="0.2" />
        </linearGradient>
      </defs>

      {/* Cast line — drawn from upper-left curving down to the hook */}
      <path
        d="M6 6 Q 22 18, 30 28 Q 38 38, 32 48"
        stroke="url(#tackleLineGrad)"
        strokeWidth="1.6"
        fill="none"
        strokeLinecap="round"
      />

      {/* Main fishhook body */}
      <path
        d="M32 12
           L32 38
           A 12 12 0 1 1 18 36
           L18 32"
        stroke="url(#tackleHookGrad)"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Hook eyelet — small ring at the top */}
      <circle
        cx="32"
        cy="11"
        r="3"
        stroke="url(#tackleHookGrad)"
        strokeWidth="2.5"
        fill="none"
      />

      {/* Barb */}
      <path
        d="M18 36 L24 32"
        stroke="url(#tackleHookGrad)"
        strokeWidth="3.5"
        strokeLinecap="round"
      />

      {/* Bait fleck / spark */}
      <circle cx="22" cy="44" r="1.6" fill="#ffd166" />
      <circle cx="26" cy="46" r="1" fill="#ffd166" opacity="0.7" />
    </svg>
  );
}
